import {
  FileUploadRules,
  PariBankAccountDetails,
  SocialAuthProviders,
  ThreeDSecureModes,
} from 'src/types/common';
import { AppSubdomains } from 'src/types/common';

export type SubdomainFlags = {
  [key in AppSubdomains]: boolean;
};

export type FeatureFlagValue<T> = T extends SubdomainFlags ? SubdomainFlags : T;

export type FEATURE_FLAGS_TYPE = {
  ENABLE_SOCIAL_LOGIN: boolean;
  ENABLE_B2B: boolean;
  ENABLE_B2B_SPEI_PAYMENT: SubdomainFlags;
  ENABLE_B2B_CREDIT_PAYMENT: SubdomainFlags;
  ENABLE_B2B_CARD_PAYMENT: SubdomainFlags;
  ENABLE_ORDER_COMPLAINTS: boolean;
  B2B_DELIVERY_FEE: number;
  B2B_EXPRESS_ORDER_LIMIT: number;
  ENABLE_LAUNCH_NOTIFICATIONS: boolean;
  ENABLE_EVENT_TRACKING: boolean;
  ENABLE_CUSTOM_SPEI_PAYMENT: SubdomainFlags;
  BANK_ACCOUNT_DETAILS: PariBankAccountDetails;
  PARI_TRANSFER_RECEIPT_RULES: FileUploadRules;
  SUPPORT_LINK: string;
  THREE_D_SECURE_MODE: ThreeDSecureModes;
  REVIEW_CATEGORIES: {
    slug: string[];
  };
  VERSION_IN_REVIEW: {
    ios: string;
    android: string;
  } | null;
  ENABLE_IN_APP_NOTIFICATIONS: boolean;
  IN_APP_NOTIFICATIONS_DURATION: number;
  BANNER_ASPECT_RATIO: string;
  ENABLE_PARI_WALLET: SubdomainFlags;
  ENABLE_VERIFY_ID: boolean;
  SOCIAL_AUTH_PROVIDERS: SocialAuthProviders;
  PROMOTIONS_PAGE_BY_CATEGORY: boolean;
  ENABLE_VERIFY_ID_PROVIDER: SubdomainFlags;
  ENABLE_WHATSAPP_OTP: boolean;
  ENABLE_SIGNUP_EMAIL_OTP: SubdomainFlags;
  ENABLE_SIGNUP_PHONE_OTP: SubdomainFlags;
  ENABLE_CARD_PAYMENT_BRICK: boolean;
  ENABLE_MP_WALLET_PAYMENT: SubdomainFlags;
  ENABLE_CLIP_PAYMENT: SubdomainFlags;
  ENABLE_AGE_CONFIRMATION_SCREEN: boolean;
  ENABLE_PROMOTIONS_INFO_BANNERS: boolean;
  RECOMMENDED_PAYMENT_METHOD: string;
  ENABLE_B2C_ACCORDION_CHECKOUT: boolean;
  ENABLE_ORDER_REVIEWS: boolean;
  ORDER_REVIEW_TAGS: { positive: string[]; negative: string[] };
  ENABLE_ADDRESS_COUNTRY_RESTRICTIONS: string | string[];
  MAP_PIN_ADDRESS_CREATION_ENABLED: boolean;
  ENABLE_OPENPAY_CARD_PROVIDER: SubdomainFlags;
  ENABLE_OPENPAY_PAYMENT: SubdomainFlags;
};

export const FEATURE_FLAGS: { [flagName in keyof FEATURE_FLAGS_TYPE]: string } =
  {
    ENABLE_SOCIAL_LOGIN: 'enable_social_login',
    ENABLE_B2B: 'enable_b2b',
    ENABLE_B2B_SPEI_PAYMENT: 'enable_b2b_spei_payment',
    ENABLE_B2B_CREDIT_PAYMENT: 'enable_b2b_credit_payment',
    ENABLE_B2B_CARD_PAYMENT: 'enable_b2b_card_payment',
    SUPPORT_LINK: 'support_link',
    ENABLE_ORDER_COMPLAINTS: 'enable_order_complaints',
    B2B_DELIVERY_FEE: 'b2b_delivery_fee',
    B2B_EXPRESS_ORDER_LIMIT: 'b2b_express_order_limit',
    ENABLE_LAUNCH_NOTIFICATIONS: 'enable_launch_notifications',
    ENABLE_EVENT_TRACKING: 'enable_event_tracking',
    ENABLE_CUSTOM_SPEI_PAYMENT: 'enable_custom_spei_payment',
    BANK_ACCOUNT_DETAILS: 'bank_account_details',
    PARI_TRANSFER_RECEIPT_RULES: 'pari_transfer_receipt_rules',
    THREE_D_SECURE_MODE: '3D_SECURE_MODE',
    REVIEW_CATEGORIES: 'review_categories',
    VERSION_IN_REVIEW: 'version_in_review',
    ENABLE_IN_APP_NOTIFICATIONS: 'ENABLE_IN_APP_NOTIFICATIONS',
    IN_APP_NOTIFICATIONS_DURATION: 'IN_APP_NOTIFICATIONS_DURATION',
    BANNER_ASPECT_RATIO: 'BANNER_ASPECT_RATIO',
    ENABLE_PARI_WALLET: 'ENABLE_PARI_WALLET',
    ENABLE_VERIFY_ID: 'ENABLE_VERIFY_ID',
    SOCIAL_AUTH_PROVIDERS: 'SOCIAL_AUTH_PROVIDERS',
    PROMOTIONS_PAGE_BY_CATEGORY: 'PROMOTIONS_PAGE_BY_CATEGORY',
    ENABLE_VERIFY_ID_PROVIDER: 'ENABLE_VERIFY_ID_PROVIDER',
    ENABLE_WHATSAPP_OTP: 'ENABLE_WHATSAPP_OTP',
    ENABLE_SIGNUP_EMAIL_OTP: 'ENABLE_SIGNUP_EMAIL_OTP',
    ENABLE_SIGNUP_PHONE_OTP: 'ENABLE_SIGNUP_PHONE_OTP',
    ENABLE_CARD_PAYMENT_BRICK: 'ENABLE_CARD_PAYMENT_BRICK',
    ENABLE_MP_WALLET_PAYMENT: 'ENABLE_MP_WALLET_PAYMENT',
    ENABLE_CLIP_PAYMENT: 'ENABLE_CLIP_PAYMENT',
    ENABLE_AGE_CONFIRMATION_SCREEN: 'ENABLE_AGE_CONFIRMATION_SCREEN',
    ENABLE_PROMOTIONS_INFO_BANNERS: 'ENABLE_PROMOTIONS_INFO_BANNERS',
    RECOMMENDED_PAYMENT_METHOD: 'RECOMMENDED_PAYMENT_METHOD',
    ENABLE_B2C_ACCORDION_CHECKOUT: 'ENABLE_B2C_ACCORDION_CHECKOUT',
    ENABLE_ORDER_REVIEWS: 'ENABLE_ORDER_REVIEWS',
    ORDER_REVIEW_TAGS: 'ORDER_REVIEW_TAGS',
    ENABLE_ADDRESS_COUNTRY_RESTRICTIONS: 'ENABLE_ADDRESS_COUNTRY_RESTRICTIONS',
    MAP_PIN_ADDRESS_CREATION_ENABLED: 'MAP_PIN_ADDRESS_CREATION_ENABLED',
    ENABLE_OPENPAY_CARD_PROVIDER: 'ENABLE_OPENPAY_CARD_PROVIDER',
    ENABLE_OPENPAY_PAYMENT: 'ENABLE_OPENPAY_PAYMENT',
  };
